import type { ReactNode } from "react";
import { clsx } from "@/src/common/utils/clsx";

interface SectionTitleProps {
	children: ReactNode;
	className?: string;
}

/** Small uppercase label used in sidebars and form section headers. */
export function SectionTitle({ children, className }: SectionTitleProps) {
	return <p className={clsx("px-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground", className)}>{children}</p>;
}
